import {createContext} from "react"

export const DataContext = createContext()
export const UserContext = createContext()
